import MapHelper from './maps/gaodeMap';

export default MapHelper;
